import request from '../utils/csrf-superagent';
import config from '../config';
import actions from '../actions/actions';
import softwareDetailsActions from '../actions/softwareDetails';
import helpActions from '../actions/help';
import {MERCHANT_OF_RECORD, USER_TYPE} from '../utils/constants';

function sendIneligibleEmail(store, ineligibilityType) {
    const state = store.getState();
    const userInfo = state.userInfoDetails && state.userInfoDetails.userInfoMetadata;
    const data = userInfo && userInfo.user ? {
        firstName: userInfo.user.firstName,
        lastName: userInfo.user.lastName,
        emailAddress: userInfo.user.emailAddress,
        companyName: userInfo.user.companyName,
        message: ineligibilityType
    } : {
        message: ineligibilityType
    };
    const helpFormData = {
        data,
        type: 'INELIGIBLE'
    };
    store.dispatch(helpActions.submitHelpForm(helpFormData));
}

function navigateByBusinessModel(store, businessModel, userType) {
    if (businessModel === MERCHANT_OF_RECORD.EG) {
        store.dispatch(actions.changeAppState('PAYOUT_DETAILS'));
    } else {
        const appState = userType === USER_TYPE.IPM ? 'MAILING_INFORMATION' : 'LISTING_MODEL';
        store.dispatch(actions.changeAppState(appState));
    }
}

function postAndNavigate(store, systemId, businessModel, advertiserId, userType) {
    request.post(`/${config.url_prefix}/api/advertiser/businessModel`)
        .send({ systemId, businessModel, advertiserId })
        .end((updateError) => {
            store.dispatch(actions.enableLoadOverLay(false));
            if (updateError) {
                store.dispatch(softwareDetailsActions.alertError('ipmob.internal.server.error'));
                return;
            }
            navigateByBusinessModel(store, businessModel, userType);
        });
}

function resolveForSWSwitchIPM(store, systemId, advertiserId, userType) {
    const advertiserBusinessModel = store.getState().businessModel?.advertiserBusinessModel;

    request.get(`/${config.url_prefix}/api/getPreferredBusinessModel?systemId=${systemId}`)
        .end((prefError, prefResponse) => {
            if (prefError) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(softwareDetailsActions.alertError('ipmob.internal.server.error'));
                return;
            }

            try {
                const { businessModel: preferredBusinessModel } = JSON.parse(prefResponse.text);

                if (!preferredBusinessModel) {
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
                    return;
                }

                if (advertiserBusinessModel === MERCHANT_OF_RECORD.EG) {
                    // IPM = MOR
                    if (preferredBusinessModel === MERCHANT_OF_RECORD.SUPPLIER) {
                        // PMSC supports Agency only → Ineligible
                        store.dispatch(actions.enableLoadOverLay(false));
                        store.dispatch(actions.showIneligibleForm('UNSUPPORTED_AGENCY_TO_MOR_SWITCH'));
                        sendIneligibleEmail(store, 'UNSUPPORTED_AGENCY_TO_MOR_SWITCH');
                    } else {
                        // PMSC supports MOR only, or both and prefers MOR/undefined → set MOR
                        postAndNavigate(store, systemId, MERCHANT_OF_RECORD.EG, advertiserId, userType);
                    }
                } else if (preferredBusinessModel === MERCHANT_OF_RECORD.UNSPECIFIED) {
                    // IPM = Agency
                    // PMSC supports both, no preference → force MOR
                    postAndNavigate(store, systemId, MERCHANT_OF_RECORD.EG, advertiserId, userType);
                } else {
                    // IPM = Agency
                    // PMSC supports Agency only (SUPPLIER) → Agency
                    // PMSC supports MOR only (EG) → MOR
                    // PMSC supports both, prefers MOR or Agency → follow preference
                    postAndNavigate(store, systemId, preferredBusinessModel, advertiserId, userType);
                }
            } catch (exp) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
            }
        });
}

function resolveForNetNewAndPPM(store, systemId, advertiserId, userType) {
    request.get(`/${config.url_prefix}/api/getPreferredBusinessModel?systemId=${systemId}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(softwareDetailsActions.alertError('ipmob.internal.server.error'));
                return;
            }

            try {
                const { businessModel } = JSON.parse(response.text);

                if (!businessModel) {
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
                    return;
                }

                if (businessModel === MERCHANT_OF_RECORD.UNSPECIFIED) {
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(actions.changeAppState('BUSINESS_MODEL'));
                } else {
                    postAndNavigate(store, systemId, businessModel, advertiserId, userType);
                }

            } catch (exp) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
            }
        });
}

function resolveBusinessModel(store, action) {
    const { systemId, advertiserId } = action.payload;
    const state = store.getState();
    const userType = state.app?.userType;
    const currency = state.userInfoDetails?.userInfoMetadata?.billingCurrencyCode;
    if (currency === 'USD' || state.app?.dyff?.SHARED_ROW_MOR_ENABLED) {
        if (userType === USER_TYPE.IPM_SOFTWARE_SWITCH) {
            resolveForSWSwitchIPM(store, systemId, advertiserId, userType);
        } else {
            resolveForNetNewAndPPM(store, systemId, advertiserId, userType);
        }
    } else {
        // For ROW currencies we won't support MOR model until dyff flag SHARED_ROW_MOR_ENABLED is enabled.
        postAndNavigate(store, systemId, MERCHANT_OF_RECORD.SUPPLIER, advertiserId, userType);
    }
}

export default resolveBusinessModel;
